import React from 'react';

/**
 * "Smart Reminder & Predictive (KI)" — heuristic timing toggles that drive
 * which patient-facing reminders go out. All copy stays in German because
 * the backend acts on it directly; this section is staff-visible only.
 */
export default function NotificationsSection({ form, setF, t }) {
  return (
    <div className="so-card p-5" data-testid="notifications-section">
      <h2 className="text-sm font-semibold mb-4">{t('settings.sections.notifications')}</h2>
      <label className="flex items-start gap-3 mb-3">
        <input type="checkbox" className="mt-0.5" checked={!!form.smart_timing_enabled} onChange={(e) => setF('smart_timing_enabled', e.target.checked)} data-testid="set-smart-timing"/>
        <span className="text-sm">{t('settings.notifications.smartTiming')}</span>
      </label>
      <label className="flex items-start gap-3">
        <input type="checkbox" className="mt-0.5" checked={!!form.predictive_enabled} onChange={(e) => setF('predictive_enabled', e.target.checked)} data-testid="set-predictive"/>
        <span className="text-sm">{t('settings.notifications.predictive')}</span>
      </label>
      <p className="mt-3 text-xs text-text-secondary">{t('settings.notifications.dsgvoNote')}</p>
    </div>
  );
}
